import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Divider, Dropdown } from 'antd';
import classNames from 'classnames';
import { ButtonBorderTabPhase } from '../Forms/Button';
import DropdownMenu from './DropdownMenu';
import classes from './TabMenu.module.less';
type Props = {
  activeKey: any;
  onChange: (v: any) => void;
  categoryTopics: any;
  keyTopic: any;
};
const categoryTopics1 = [{
  name: 'Semua Topik',
  full_slug: 'semua-topik',
  slug: '/artikel'
}, {
  name: 'Program Hamil',
  full_slug: 'pra-kehamilan',
  slug: '/artikel/pra-kehamilan/promil/buat-mama'
}, {
  name: 'Kehamilan',
  full_slug: 'kehamilan',
  slug: '/artikel/kehamilan/trimester-1/buat-mama'
}, {
  name: 'Tumbuh Kembang',
  full_slug: 'pasca-kehamilan',
  slug: '/artikel/pasca-kehamilan/newborn/buat-mama'
}];
export function checkSubAndRedirect(sub: any) {
  if (typeof sub === 'string') {
    const isMatch = categoryTopics1.some(topic => topic.slug === sub);
    if (isMatch) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}
const TabMenu = (props: Props) => {
  const {
    activeKey,
    keyTopic
  } = props;
  const router = useRouter();
  const sub = router.query.sub;
  const onChange = (e: any) => {
    router.push(`/${e}`);
  };
  const isMatched = checkSubAndRedirect(sub);
  const [selectPhase, setSelectedPhase] = useState<any>('');
  useEffect(() => {
    if (isMatched) {
      router.push(`/${router.query.sub}`);
    }
  }, [isMatched]);
  useEffect(() => {
    setSelectedPhase(router.query.phase === undefined ? '/artikel' : `/artikel/${router.query.phase}`);
  }, []);
  return <div className={classes.wrapper}>
			<div className={classes.tabs}>
				{categoryTopics1?.slice(0, keyTopic)?.map((categoryTopic: any, id: number) => {
        const key = `${id + 1}__${categoryTopic.slug}`;
        const keys = categoryTopic.slug === '/artikel' ? categoryTopic.slug : categoryTopic.slug.split('/').slice(0, -2).join('/');
        const isActiveKey = keys === selectPhase;
        return <div key={key} className={classNames(classes.tab, {
          [classes.active]: isActiveKey
        })}>
							<a href={categoryTopic.slug} id={'artikel-' + categoryTopic.slug}>
								<ButtonBorderTabPhase style={{
              backgroundColor: 'transparent',
              color: isActiveKey === true ? '#F36D6D' : '#A19797',
              cursor: 'pointer',
              borderRadius: '8px',
              fontWeight: 700,
              borderBottom: isActiveKey === true ? '#F36D6D 4px solid' : 'transparent',
              borderTop: 'transparent',
              borderLeft: 'transparent',
              borderRight: 'transparent',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
              paddingLeft: '0px',
              paddingRight: '0px'
            }} text={categoryTopic?.name} />
							</a>
						</div>;
      })}

				{categoryTopics1?.length > keyTopic && <Dropdown dropdownRender={() => <DropdownMenu menu={categoryTopics1} active={activeKey} onChangeFn={onChange} keyTopic={keyTopic} />} trigger={['click']} placement="bottomRight" arrow>
						<div className={classNames(classes.other, {
          [classes.active]: activeKey?.split('__')?.[0] > keyTopic
        })} onClick={e => e.preventDefault()}>
							Lainnya
						</div>
					</Dropdown>}
			</div>
			<div>
				<Divider className={classes.divider}></Divider>
			</div>
		</div>;
};
export default TabMenu;